/* global jQuery */

(function ($) {
	"use strict";

	$(document).ready(function(){

		$(".q-qsc__agenda-tabs a").each( function(  ) {

			var tab = $(this);

			tab.on("click", function(){

				var panel = tab.data("tab");
	
				$(".q-qsc__agenda-tabs").removeClass("tab-open");
				$(".q-qsc__agenda-tabs li").removeClass("active-tab");
				$(".q-qsc__agenda-tab-content").removeClass("active-panel");
	
				tab.parent().addClass("active-tab");
				$( "#"+ panel ).addClass("active-panel");
			});

		});

		$(".mobile-tab-chevron").on("click", function() {
			$(".q-qsc__agenda-tabs").toggleClass("tab-open");
		});

		var hashValue, element;

		function tabChange(){

			hashValue = window.location.hash.replace(/^#/,'');

			if ( hashValue.length ) {
				element = $("[data-tab='" + hashValue + "']");

				if( element.length ){

					$(".q-qsc__agenda-tabs li").removeClass("active-tab");
					$(".q-qsc__agenda-tab-content").removeClass("active-panel");

					element.parent().addClass("active-tab");
					$( "#"+ hashValue ).addClass("active-panel");

				}
			}
		}

		if (window.location.hash) {
			tabChange();
		}

		$( window ).on( 'hashchange', function() {

			tabChange();

		});

	});
}(jQuery));
